import Service from '@ember/service';
import { storageFor } from 'ember-local-storage';
import { inject as service } from '@ember/service';
import FeaturesService from 'ember-feature-flags/services/features';

const ALLOWED_FEATURE_FLAGS = ['liquidPlayground'];
const ALLOWED_ANONYMOUS_FEATURE_FLAGS: string[] = [];

export default class PersistentFeaturesService extends Service {
  @service features!: FeaturesService;
  @storageFor('cio-features') persistentFeatures: any;

  loadFeatures() {
    this.load(ALLOWED_FEATURE_FLAGS);
  }

  loadAnonymousFeatures() {
    this.load(ALLOWED_ANONYMOUS_FEATURE_FLAGS);
  }

  enable(flag: string) {
    this.features.enable(flag);
    this.persistentFeatures.set(flag, true);
  }

  disable(flag: string) {
    this.features.disable(flag);
    this.persistentFeatures.set(flag, false);
  }

  private load(flags: string[]) {
    let { features: featuresService } = this;
    let features = this.persistentFeatures;

    flags.forEach((flag) => {
      let enabled = features.get(flag);

      if (enabled === true) {
        featuresService.enable(flag);
      } else if (enabled === false) {
        featuresService.disable(flag);
      }
    });
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'persistent-features': PersistentFeaturesService;
  }
}
